import { confirmable, ConfirmDialog, createConfirmation } from "react-confirm";

import { DeleteConfirmation } from "@/Components/v2/molecule/ConfirmationDialog";

interface DeleteConfirmationProps {
  scenarioName: string;
  title?: string;
  subtitle?: string;
  deleteButtonText?: string;
  cancelButtonText?: string;
}

const DeleteScenarioDialog: ConfirmDialog<DeleteConfirmationProps, boolean> = ({
  show,
  proceed,
  scenarioName,
  title = "Delete Scenario",
  subtitle = `Are you sure you want to delete "${scenarioName}"? This action cannot be undone.`,
  deleteButtonText = "Delete",
  cancelButtonText = "Cancel",
}) => (
  <DeleteConfirmation
    open={show}
    title={title}
    subtitle={subtitle}
    deleteButtonText={deleteButtonText}
    cancelButtonText={cancelButtonText}
    onDelete={() => proceed(true)}
    onCancel={() => proceed(false)}
  />
);

const ConfirmableDialog = confirmable(DeleteScenarioDialog);

export const confirmDeleteScenario = createConfirmation(ConfirmableDialog);
